const MUTATE = 'MUTATE'
const SET_ANSWER = 'SET_ANSWER'
const SET_DEMOGRAPHICS = 'SET_DEMOGRAPHICS'
const SET_EMAIL = 'SET_EMAIL'
const RESET_QUIZ_STATE = 'RESET_QUIZ_STATE'

const getDefaultState = () => ({
  email: '',
  answers: {},
  demographics: {
    gender: '',
    age: '',
    waist: '',
    postalCode: '',
    menopausal: null
  }
})

export const state = () => getDefaultState()

export const actions = {
  setAnswer({ commit }, payload) {
    if (payload.questionId < 13) {
      commit(SET_ANSWER, payload)
    } else {
      commit(SET_DEMOGRAPHICS, payload)
    }
  },

  resetQuizState({ commit }, payload) {
    commit(RESET_QUIZ_STATE)
  },

  set({ commit }, { property, data }) {
    commit(MUTATE, {
      property,
      data
    })
  }
}

export const mutations = {
  [SET_EMAIL](state, payload) {
    state.email = payload
  },

  [SET_ANSWER](state, { questionId, data }) {
    state.answers[questionId] = data
  },

  [SET_DEMOGRAPHICS](state, payload) {
    state.demographics = payload.data
  },

  [MUTATE](state, { property, data }) {
    state[property] = data
  },

  [RESET_QUIZ_STATE](state) {
    Object.assign(state, getDefaultState())
  }
}

export const getters = {
  getAnswerByQuestionId(state) {
    return questionId => state.answers[questionId] || []
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
